import { MEDIA_TYPES_FOR_END_CLIENT } from "../../../../layouts/proposal-template/ProposalTemplateEndClient.config"
import ProposalHeroCircleSquare from "./ProposalHeroCircleSquare"
import ProposalHeroTriangle from "./ProposalHeroTriangle"
import { ReactComponent as LinkIcon } from "./assets/linkIcon.svg"
import { ReactComponent as PDFIcon } from "./assets/pdfIcon.svg"
import { ReactComponent as PlayIcon } from "./assets/playIcon.svg"

// const fourContainerLayout = [
//   "col-5 flex align-items-end justify-content-end",
//   "col-5 flex align-items-end justify-content-start",
//   "col-5 flex align-items-end justify-content-end",
//   "col-5 flex align-items-end justify-content-start"
// ]
const threeContainerSquareLayout = [
  "col-5 flex align-items-start justify-content-end mr-2",
  "col-5 flex align-items-start justify-content-start",
  "col-12 flex align-items-end justify-content-center",
]
const threeContainerCircleLayout = [
  "col-12 flex align-items-end justify-content-center",
  "col-5 flex align-items-start justify-content-end mr-2",
  "col-5 flex align-items-start justify-content-start",
]
const threeContainerTriangleLayout = [
  "TriangleLayout TriangleLayout-0 pointer-events-none absolute left-50 top-50 ",
  "TriangleLayout TriangleLayout-1 pointer-events-none absolute left-50 bottom-50",
  "TriangleLayout  TriangleLayout-2 pointer-events-none absolute right-50 bottom-50",
]

export const proposalHeroTypes = {
  circle: {
    label: "circle",
    Component: ProposalHeroCircleSquare,
    layout: {
      3: threeContainerCircleLayout,
      // 4: fourContainerLayout
    }
  },
  rectangle: {
    label: "rectangle",
    Component: ProposalHeroCircleSquare,
    layout: {
      3: threeContainerSquareLayout,
      // 4: fourContainerLayout
    }
  },
  triangle: {
    label: "triangle",
    Component: ProposalHeroTriangle,
    layout: {
      3: threeContainerTriangleLayout,
      // 4: fourContainerLayout
    }
  },
}

export const proposalHeroShapesEnum = Object.getOwnPropertyNames(proposalHeroTypes)
export const proposalHeroColorTypes = {
  orange: "orange",
  blue: "blue",
  purple: "purple",
  yellow: "yellow",
}
export const proposalInnerTypes = {
  PDF: "pdf",
  IMAGES: "images",
  LINK: "link",
  VIDEO: "video"
}

export const typeIconMap = {
  [proposalInnerTypes.PDF]: <PDFIcon />,
  [proposalInnerTypes.IMAGES]: <PlayIcon />,
  [proposalInnerTypes.LINK]: <LinkIcon />,
  [proposalInnerTypes.VIDEO]: <PlayIcon />,
}



export function selectProposalLayout(containerType, numberOfContainers) {
  return { HeroContainerType: proposalHeroTypes[containerType].Component, layoutArray: proposalHeroTypes[containerType].layout[numberOfContainers] }
}



export const borderRadius = {
  [proposalHeroTypes.circle.label]: "border-circle",
  [proposalHeroTypes.rectangle.label]: "border-round-3xl"
}

export function handleTypeSpecificClick({ type, pdfFile, link, setShowProposalModal }) {
  const protocolString = "https://"
  if (type === MEDIA_TYPES_FOR_END_CLIENT.LINK) {
    let finalLink = link;
    if (link.indexOf(protocolString) !== 0) {
      finalLink = protocolString + link;
    }
    return window.open(finalLink)
  }
  if (type === MEDIA_TYPES_FOR_END_CLIENT.DOCUMENT) {
    if (pdfFile?.url) {
      return window.open(pdfFile.url)
    }
    else {
      return window.open(link)
    }
  }
  if (type === MEDIA_TYPES_FOR_END_CLIENT.VIDEO) {
    return setShowProposalModal()
  }
  if (type === MEDIA_TYPES_FOR_END_CLIENT.IMAGES) {
    return setShowProposalModal()
  }
}
export const handleHeroMediaType = (type, pdfFile, link = "", video = "", images = []) => {
  let error = false;
  // if (type === MEDIA_TYPES_FOR_END_CLIENT.VIDEO) {
  //   if (!video || video?.length === 0) {
  //     error = true;
  //   }
  // }
  if (type === MEDIA_TYPES_FOR_END_CLIENT.LINK) {
    if (!link || link?.length === 0) {
      error = true;
    }
  }
  else if (type === MEDIA_TYPES_FOR_END_CLIENT.DOCUMENT) {
    if (!pdfFile?.url) {
      error = true;
    }
  }
  // else if (type === MEDIA_TYPES_FOR_END_CLIENT.IMAGES) {
  //   if (images.length === 0) {
  //     error = true;
  //   }
  // }
  return error;
}


export const triangleHeroDropShadow={
  [proposalHeroColorTypes.purple]:"drop-shadow(0px 0px 12px #671591bf)",
  [proposalHeroColorTypes.yellow]:"drop-shadow(0px 0px 12px #E9C610bf)",
  [proposalHeroColorTypes.orange]:"drop-shadow(0px 0px 12px #FF8A00bf)",
  [proposalHeroColorTypes.blue]:"drop-shadow(0px 0px 12px #4777FAbf)",
}